module.exports = __webpack_public_path__ + "static/media/stignatius.58124a41.webp";